import React from "react";
import TextView from "../../TextView";
import ReusableButton from "../../WheelGallery/Button";
import { colors } from "../../../utils";
import { ASSETS } from "../../../utils/config";
import { useParams } from "react-router-dom";
import { getLoggedInUser } from "../../../utils/helpers";
import { Box, Stack } from "@mui/material";

const EmptyState = ({ NestedFolder = true, title, descriptionText }) => {
    const { id } = useParams();
    const isUserProfile = id == getLoggedInUser()?.id;

    if (NestedFolder) {
        return (
            <Box
                gap={2}
                py={3}
                mt={1}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px dashed rgba(152, 162, 179, 1)",
                    backgroundColor: "#F9FAFB",
                }}
            >
                <img
                    src={ASSETS.segmentEditor.EmptyNestedFolder}
                    width={80}
                    height={80}
                    alt="No folder created yet!"
                />
                <TextView variant="title" style={{ marginTop: "5px" }}>
                    {title}
                </TextView>
                <TextView
                    variant="subtitle"
                    style={{ marginTop: "15px", textAlign: "center", width: "60%" }}
                >
                    {descriptionText}
                </TextView>
            </Box>
        );
    }

    return (
        <Stack
            gap={2}
            py={3}
            mt={1}
            style={{
                background: `linear-gradient(45deg, #F7FED5, #CCFEFF, #FDCFFE, #F5EEDE)`,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
            }}
        >
            <img
                src={ASSETS.segmentEditor.EmptyFolder}
                width={80}
                height={80}
                alt="No folder created yet!"
            />
            <TextView
                style={{ color: "rgba(0, 0, 0, 0.57)" }}
                variant="title"
            >
                No folders to see here!
            </TextView>
            {isUserProfile && (
                <ReusableButton
                    text="Create a folder"
                    onClick={() => {}}
                    customStyles={{
                        backgroundColor: colors.PrimaryPurple,
                    }}
                />
            )}
        </Stack>
    );
};

export default EmptyState;
